import { render, staticRenderFns } from "./modal_cadastro.vue?vue&type=template&id=e02cbe86"
import script from "./modal_cadastro.vue?vue&type=script&lang=js"
export * from "./modal_cadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports